// react core
import { useContext, useState } from "react";

// material design
import Box from "@mui/material/Box";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import Typography from "@mui/material/Typography";
import Collapse from "@mui/material/Collapse";

// entzy context
import configEntzy from "components/config/ConfigEntzy";
import { MainContext } from "components/main/MainContext";
import { EventContext } from "components/event/EventContext";
import { ActionLoader } from "components/utils/common/CommonLoaders";
import { TextTag } from "components/utils/common/CommonTags";

// fonts and colors
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell as iconNotifications } from "@fortawesome/pro-solid-svg-icons";

function ActionMessagingSettings(props) {
  const mainContext = useContext(MainContext);
  const eventContext = useContext(EventContext);

  const isRunnerSide = props.source === "runner" ? true : false;
  const isRunnerView = props.viewer === "runner" ? true : false;
  const isRiderSide = props.source === "rider" ? true : false;
  const isRiderView = props.viewer === "rider" ? true : false;

  const isDisabled =
    isRunnerSide && isRiderView
      ? true
      : isRiderSide && isRunnerView
      ? true
      : false;

  const roomName = props.roomName || eventContext.state.messaging.activeRoom;

  const [mailAlerts, setMailAlerts] = useState(
    eventContext.state.messaging.rooms[roomName].settingsHydrated &&
      eventContext.state.messaging.rooms[roomName].settingsData.mail,
  );
  const [pushAlerts, setPushAlerts] = useState(
    eventContext.state.messaging.rooms[roomName].settingsHydrated &&
      eventContext.state.messaging.rooms[roomName].settingsData.push,
  );
  const [loading, setLoading] = useState(false);

  const [showSettings, setShowSettings] = useState({
    value: false,
    source: "load",
  });

  const handleShowSettings = () => {
    setShowSettings({ value: !showSettings.value, source: "click" });
  };

  const handleMailAlerts = (event) => {
    setMailAlerts(event.target.checked);
    handleUpdateSettings({
      push: pushAlerts,
      mail: event.target.checked,
      changed: "mail",
    });
  };
  const handlePushAlerts = (event) => {
    setPushAlerts(event.target.checked);
    handleUpdateSettings({
      push: event.target.checked,
      mail: mailAlerts,
      changed: "push",
    });
  };
  const handleUpdateSettings = async (settings) => {
    setLoading(true);
    const response = await eventContext.prepareUpdateMessageSettings({
      EventId: eventContext.state.event.data.EventId,
      RoomName: roomName,
      Settings: settings,
    });
    if (response.alert) {
      mainContext.updateAlert(response);
    } else {
      eventContext.updateMessageSettings(response);
    }
    setLoading(false);
  };

  // after small delay close notification settings
  // useEffect(() => {
  //   if (showSettings.value && showSettings.source !== "click") {
  //     const timer = setTimeout(() => {
  //       setShowSettings(false);
  //     }, 3000);
  //     return () => clearTimeout(timer);
  //   }
  // }, [showSettings]);

  return (
    <Box className="box-default text-center">
      <Box
        className="box-default"
        // sx={{
        //   pl: isRunnerSide ? 0 : configEntzy.APP_SPACING_SM,
        //   pr: !isRunnerSide ? 0 : configEntzy.APP_SPACING_SM,
        // }}
      >
        {eventContext.state.messaging.rooms[roomName].settingsHydrated && (
          <Box
            key={
              eventContext.state.messaging.rooms[roomName].settingsData
                .SettingId
            }
            className="box-default"
            // className={
            //   "box-default nooverflow" +
            //   (isDisabled ? "bg-black-t10" : " bg-black-t50")
            // }
            sx={{
              borderRadius: configEntzy.BORDER_SIZE_XL,
            }}
          >
            <Box
              className={"box-default" + (isDisabled ? "" : " action-pointer")}
              onClick={isDisabled ? undefined : handleShowSettings}
              sx={{
                pt: configEntzy.APP_SPACING_MD2X,
                pb: showSettings.value
                  ? configEntzy.APP_SPACING_MD
                  : configEntzy.APP_SPACING_MD2X,
              }}
            >
              <Typography
                variant="h6"
                color={
                  isDisabled
                    ? "divider"
                    : !mailAlerts && !pushAlerts
                    ? "grey"
                    : "secondary.dark"
                }
              >
                <span>
                  <FontAwesomeIcon icon={iconNotifications} />
                  <span>&nbsp;&nbsp;</span>
                </span>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                {isDisabled
                  ? "--"
                  : !mailAlerts && !pushAlerts
                  ? " OFF"
                  : mailAlerts && pushAlerts
                  ? " ON"
                  : mailAlerts
                  ? " MAIL"
                  : pushAlerts
                  ? " PUSH"
                  : " --"}
              </Typography>
            </Box>
            {loading ? (
              <Box className="box-default">
                <ActionLoader size="sm" />
              </Box>
            ) : (
              <Collapse
                in={showSettings.value}
                timeout={{
                  enter: configEntzy.TRANSITIONS.fast,
                  exit: configEntzy.TRANSITIONS.default,
                }}
              >
                <Box className="box-default">
                  <Box
                    className="box-default upper-case"
                    // sx={{ pt: configEntzy.APP_SPACING_MD }}
                  >
                    <Typography variant="subtitle2" color="primary">
                      Notifications
                    </Typography>
                  </Box>
                  <Box
                    className="box-default"
                    sx={{ pt: configEntzy.APP_SPACING_MD }}
                  >
                    <TextTag
                      size="sm"
                      bgColor="black"
                      color="white"
                      rounded={true}
                      textNoCasing={true}
                      noMask={true}
                      edges={true}
                      text={
                        <span>
                          <span>Room</span>
                        </span>
                      }
                      subText={
                        <span className="upper-case">
                          {roomName.replace("|", " | ")}
                        </span>
                      }
                    />
                  </Box>
                  <Box
                    className="box-default"
                    sx={{ pt: configEntzy.APP_SPACING_MD }}
                  >
                    <FormControlLabel
                      control={
                        <Switch
                          color="highlight"
                          disabled={isDisabled}
                          checked={isDisabled ? false : pushAlerts}
                          onChange={handlePushAlerts}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      }
                      label="Push"
                      labelPlacement="start"
                      // labelPlacement={isRunnerSide ? "end" : "start"}
                    />
                  </Box>
                  <Box
                    className="box-default"
                    sx={{
                      pt: configEntzy.APP_SPACING_MD,
                      pb: configEntzy.APP_SPACING_MD2X,
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Switch
                          color="highlight"
                          disabled={isDisabled}
                          checked={isDisabled ? false : mailAlerts}
                          onChange={handleMailAlerts}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      }
                      label="Mail"
                      labelPlacement="start"
                      // labelPlacement={isRunnerSide ? "end" : "start"}
                    />
                  </Box>
                </Box>
              </Collapse>
            )}
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default ActionMessagingSettings;
